import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ParentGuardianDialogOptions } from './parentguardian-dialog';


@Component({
    selector: 'app-parentguardian-dialog-component',
    styleUrls: ['./parentguardian-dialog.component.scss'],
    templateUrl: './parentguardian-dialog.component.html',
})
export class ParentGuardianDialogComponent {
    TitleText?: string;
    MessageText!: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;

    FirstName?: string;
    LastName?: string;
    Email?: string;
    Phone?: string;

    emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // emailRegex: RegExp = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

    constructor(
        private dialogRef: MatDialogRef<ParentGuardianDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: ParentGuardianDialogOptions
    ) {
        const self = this;
        self.TitleText = data.TitleText || 'Information';
        self.MessageText = data.MessageText || '';
        self.OKText = data.OKText || 'OK';
        self.CancelText = data.CancelText || 'CANCEL';
        self.IconColor = data.IconColor || 'black';
        self.IconName = data.IconName || 'info';
        self.ShowIcon = data.ShowIcon || false;

        self.FirstName = data.FirstName;
        self.LastName = data.LastName;
        self.Email = data.Email;
        self.Phone = data.Phone;
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    OKHandler() {
        if (!this.IsValidFields()) return;

        this.dialogRef.close({
            FirstName: this.FirstName,
            LastName: this.LastName,
            Email: this.Email,
            Phone: this.Phone,
        });
    }

    IsValidEmail(email: string): boolean {
        if (!this.emailRegex.test(email?.trim()) ) {
            return false; 
        }

        return true;        
    }

    IsValidFields(): boolean {
        if (!this.FirstName || !this.LastName || !this.Email || !this.Phone) {
            return false;
        }

        if (!this.IsValidEmail(this.Email)) {
            return false;
        }

        return true;
    }
}
